/* import __COLOCATED_TEMPLATE__ from './product-expiration-badge.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();